import en from './en';
import tr from './tr';

export default {
  en,
  tr
};
